// extracted by mini-css-extract-plugin
export default {"github__actions":"Referral_github__actions__G1C07","title":"Referral_title__Yp4F1","link_module":"Referral_link_module__OZsDN"};